/* Session-scoped prospect identity shared across the marketing site's forms.
   Filled by the /product-tour gate; read back to prefill the /demo booking form
   (and any future form), so a prospect never types their details twice.
   sessionStorage on purpose: identity should not outlive the browsing session. */

export interface CultivLead {
  firstName: string;
  lastName: string;
  email: string;
  agency: string;
  optin: boolean;
}

const LEAD_KEY = 'cultiv.lead';
const WATCH_UNLOCKED_KEY = 'cultiv.watch.unlocked';

export function saveCultivLead(lead: CultivLead): void {
  try {
    sessionStorage.setItem(LEAD_KEY, JSON.stringify(lead));
  } catch {
    /* storage unavailable (private mode/quota) — prefill is best-effort */
  }
}

export function getCultivLead(): CultivLead | null {
  try {
    const raw = sessionStorage.getItem(LEAD_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (typeof p?.email !== 'string') return null;
    return {
      firstName: typeof p.firstName === 'string' ? p.firstName : '',
      lastName: typeof p.lastName === 'string' ? p.lastName : '',
      email: p.email,
      agency: typeof p.agency === 'string' ? p.agency : '',
      optin: Boolean(p.optin),
    };
  } catch {
    return null;
  }
}

export function setWatchUnlocked(): void {
  try {
    sessionStorage.setItem(WATCH_UNLOCKED_KEY, '1');
  } catch {
    /* best-effort */
  }
}

export function isWatchUnlocked(): boolean {
  try {
    return sessionStorage.getItem(WATCH_UNLOCKED_KEY) === '1';
  } catch {
    return false;
  }
}
